<!--  -->
<template>
  <div class="detail-container">
    <div class="detail-box">
      <div class="detail-top">
        <span class="top-title">
          当前状态:
          <div class="top-status" v-if="status === 0">
            <span>未审核</span>
            <img src="~@/assets/images/notApproved.svg" class="iconFont" />
          </div>
          <div class="top-status" v-if="status === 1">
            <span>已通过</span>
            <img src="~@/assets/images/pass.svg" class="iconFont" />
          </div>
          <div class="top-status" v-if="status === 2">
            <span>未通过</span>
            <img src="~@/assets/images/notPass.svg" class="iconFont" />
          </div>
        </span>
        <div class="top-btn">
          <a-button
            type="primary"
            v-if="status !== 1"
            @click="messageStatusChange(1)"
            :loading="statusSuccessLoading"
          >通过</a-button>
          <a-button
            type="danger"
            class="danger"
            v-if="status === 1 || status === 0"
            :loading="statusFailedLoading"
            @click="messageStatusChange(2)"
          >驳回</a-button>
        </div>
      </div>
      <a-collapse v-model:activeKey="activeKey" :expand-icon-position="'right'" :bordered="false">
        <template #expandIcon="{ isActive }">
          <caret-right-outlined :rotate="isActive ? 90 : 0" />
        </template>
        <a-collapse-panel key="1" header="用户基本信息" :style="customStyle">
          <div class="key-list">
            <div class="key-item" v-for="(item,index) in key1List" :key="index">
              <span class="item-title">{{item.title}}:</span>
              <span class="item-text">{{item.content}}</span>
              <span class="item-edit" v-if="item.isEdit">
                <Icon icon="edit-2-line" />
                <a @click="editChange">修改</a>
              </span>
            </div>
          </div>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="留言信息" :style="customStyle">
          <div class="key-list">
            <div class="key-item" v-for="(item,index) in otherList" :key="index">
              <span class="item-title">{{item.key}}:</span>
              <span class="item-text">{{item.value}}</span>
            </div>
          </div>
        </a-collapse-panel>
        <a-collapse-panel key="3" header="留言内容" :style="customStyle">
          <div class="key-list2">
            <div class="key-item">
              <span class="item-title">留言内容:</span>
              <span class="item-text">{{messageText}}</span>
            </div>
            <div class="key-item">
              <span class="item-title">上传图片:</span>
              <span class="item-img">
                <img
                  :src="item"
                  v-for="(item,index) in messageImgList"
                  :key="index"
                  class="img"
                  v-viewer
                />
              </span>
            </div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <a-modal v-model:visible="visible" title="修改获赞数量" @ok="handleOk" okText="确定" cancelText="取消">
      <a-input v-model:value="editValue" />
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import { CaretRightOutlined, CheckCircleOutlined } from "@ant-design/icons-vue";
import { messageDetail, messageLikeNum, messageStatus } from "@/api/index";
import { useRoute } from "vue-router";
import Icon from "@/layout/icon";
import { message } from "ant-design-vue";
import dayjs from "dayjs";

// 导入的其他文件 例如：import moduleName from 'modulePath';
export default defineComponent({
  components: {
    CaretRightOutlined,
    CheckCircleOutlined,
    Icon
  },
  setup() {
    const route = useRoute();
    const state = reactive({
      visible: false,
      statusSuccessLoading: false,
      statusFailedLoading: false,
      editValue: null,
      status: null,
      messageText: "",
      messageImgList: [],
      data: [
        {
          like: 33333
        }
      ],
      columns: [
        {
          dataIndex: "like",
          key: "like",
          slots: { title: "当前获赞数量", customRender: "like" }
        },
        {
          title: "Action",
          key: "action",
          slots: { customRender: "action" }
        }
      ],
      key1List: [
        {
          title: "UID",
          key: "uid",
          content: ""
        },
        {
          title: "语种",
          content: "",
          key: "language"
        },
        {
          title: "用户联系方式",
          content: "",
          key: "email"
        },
        {
          title: "服务器",
          content: "karakura",
          key: "server"
        },
        {
          title: "角色名称",
          content: "",
          key: "roleName"
        },
        {
          title: "留言时间",
          content: "",
          key: "createdAt"
        },
        {
          title: "当前获赞数量",
          content: "",
          key: "likeNum",
          isEdit: true
        }
      ],
      otherList: []
    });
    const customStyle =
      "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden";
    const activeKey = ref(["1", "2", "3"]);
    const editChange = () => {
      state.visible = true;
    };
    const getDetail = async () => {
      const res = await messageDetail(route.query.id);
      console.log(res, "ressss");
      const { message } = res.data;
      state.status = message.status;
      state.messageText = message.text;
      state.otherList = message.other;
      state.messageImgList = message.images;
      state.editValue = message.likeNum;
      state.key1List.forEach(item => {
        switch (item.key) {
          case "uid":
            item.content = message.uid;
            break;
          case "language":
            item.content = message.language;
            break;
          case "email":
            item.content = message.email;
            break;
          case "server":
            item.content = message.server;
            break;
          case "roleName":
            item.content = message.roleName;
            break;
          case "likeNum":
            item.content = message.likeNum;
            break;
          case "createdAt":
            item.content = dayjs(message.createdAt * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            break;
        }
      });
    };
    const handleOk = async () => {
      const res = await messageLikeNum(route.query.id, {
        likeNum: state.editValue
      });
      console.log(res, "?????????999");
      state.visible = false;
      message.success("修改成功");
      getDetail();
    };
    const messageStatusChange = async status => {
      if (status === 1) {
        state.statusSuccessLoading = true;
      } else {
        state.statusFailedLoading = true;
      }
      const res = await messageStatus({ idArr: [route.query.id], status });
      console.log(res, "hdhhdhdhh");
      setTimeout(() => {
        state.statusSuccessLoading = false;
        state.statusFailedLoading = false;
      }, 2000);
      getDetail();
    };
    onMounted(() => {
      getDetail();
    });
    return {
      ...toRefs(state),
      activeKey,
      customStyle,
      editChange,
      handleOk,
      messageStatusChange
    };
  }
});
</script>
<style lang="less">
.detail-box .ant-collapse-header {
  text-align: left;
  font-size: 16px !important;
  font-weight: 500 !important;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import "./index.less";
</style>